import { render, staticRenderFns } from "./CartItemNote.vue?vue&type=template&id=88ca7662&scoped=true&"
import script from "./CartItemNote.vue?vue&type=script&lang=js&"
export * from "./CartItemNote.vue?vue&type=script&lang=js&"
import style0 from "./CartItemNote.vue?vue&type=style&index=0&id=88ca7662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ca7662",
  null
  
)

/* custom blocks */
import block0 from "./CartItemNote.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "CartItemNote.vue"
export default component.exports